/*
 * Copyright (c) 2025 Ipivot Corporation.
 * All rights reserved.
 * This software is the confidential and proprietary information of
 *  Ipivot Corporation ("Confidential Information").
 */
import React from 'react';
import { Container } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { useSearchParams } from 'react-router-dom';
export interface FingerprintFilterParams {
    selected?: string;
  layer: number;
  tag: string;
  search: string;
}

export function FingerprintsFilterControls({ filter, setFilter, onIdSearch, onIdInputChange } : { filter: FingerprintFilterParams, setFilter: (f: FingerprintFilterParams) => void, onIdSearch?: (id: number) => void, onIdInputChange?: (value: string) => void }) {
    const [idInput, setIdInput] = React.useState<string>('');
    const [searchInput, setSearchInput] = React.useState<string>(filter.search || '');
    const [searchParams, setSearchParams] = useSearchParams();

    React.useEffect(() => {
        setSearchInput(filter.search || '');
    }, [filter.search]);

    React.useEffect(() => {
        if ((filter.search || '') === searchInput) {
            return;
        }

        const timer = window.setTimeout(() => {
            setFilterParam(filter, 'search', searchInput);
        }, 250);

        return () => {
            window.clearTimeout(timer);
        };
    }, [searchInput, filter]);

    function setFilterParam(nfilter : FingerprintFilterParams, param : keyof FingerprintFilterParams, value : any) {
        if (value !== undefined && value !== null && value !== '') {
            setFilter({ ...nfilter, [param]: value });
        } else {
            setFilter({ ...nfilter, [param]: undefined });
        }
    }

    function handleIdSearchSubmit() {
        if (!idInput) {
            return;
        }
        const id = parseInt(idInput, 10);
        if (!id) {
            return;
        }
        const next = new URLSearchParams(searchParams);
        next.set('view', String(id));
        setSearchParams(next);
        if (onIdSearch) {
            onIdSearch(id);
        }
    }

    return (
        <Container>
            <Form className="p-3">
                <Row className="g-3">
                    <Col md={3}>
                        <Form.Label htmlFor="search">Search</Form.Label>
                        <Form.Control
                            type="text"
                            id="search"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                        />
                    </Col>
                    <Col md={2}>
                        <Form.Label htmlFor="layer">Layer</Form.Label>
                        <Form.Control
                            type="string"
                            id="layer"
                            value={filter.layer ? String(filter.layer) : ''}
                            onChange={(e) => {
                                if (e.target.value) {
                                    setFilterParam(filter, 'layer', parseInt(e.target.value));
                                } else {
                                    setFilterParam(filter, 'layer', undefined);
                                }
                            }}
                        />
                    </Col>
                    <Col md={2}>
                        <Form.Label htmlFor="selected">Selected</Form.Label>
                        <Form.Select
                            id="selected"
                            value={filter.selected === undefined ? 'any' : filter.selected === 'inws' ? 'selected' : 'not-selected'}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (value === 'any') {
                                    setFilterParam(filter, 'selected', undefined);
                                } else if (value === 'selected') {
                                    setFilterParam(filter, 'selected', 'inws');
                                } else {
                                    setFilterParam(filter, 'selected', 'notinws');
                                }
                            }}
                        >
                            <option value="any">Any</option>
                            <option value="selected">Selected</option>
                            <option value="not-selected">Not Selected</option>
                        </Form.Select>
                    </Col>
                    <Col md={3}>
                        <Form.Label htmlFor="tag">Tag</Form.Label>
                        <Form.Control
                            type="text"
                            id="tag"
                            value={filter.tag}
                            onChange={(e) => setFilterParam(filter, 'tag', e.target.value)}
                        />
                    </Col>
                    <Col md={2}>
                        <Form.Label htmlFor="id">Id</Form.Label>
                        <Form.Control
                            type="number"
                            id="id"
                            value={idInput}
                            onChange={(e) => {
                                setIdInput(e.target.value);
                                if (onIdInputChange) {
                                    onIdInputChange(e.target.value);
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && idInput) {
                                    handleIdSearchSubmit();
                                }
                            }}
                        />
                    </Col>
                </Row>
            </Form>
        </Container>
    );
}

export default FingerprintsFilterControls;